<template>
  <div>
    <Calendar
      :masks="masks"
      :attributes="attributes"
      :rows="rows"
      :from-date="startDate"
      :minDate="startDate"
      :maxDate="endDate"
      :class="{
        'custom-calendar__compressed': compress,
        'custom-calendar__normal': !compress,
        'custom-calendar__column': isColumn
      }"
      titlePosition="left"
      navVisibility="hidden"
      locale="pt-BR"
      class="custom-calendar"
      disable-page-swipe
      is-expanded
      trim-weeks
    >
      <!-- RECEBE O SLOT DAY-CONTENT DO PAI OU USA O CONTEÚDO DEFAULT -->
      <template v-slot:day-content="slotData">
        <slot name="day-content" v-bind="slotData">
          <div class="custom-calendar--day">
            <div
              v-if="!slotData.attributes || slotData.attributes.length === 0"
              class="date-header"
            >
              <span class="disponibility-flag">
                <span class="day-label day-label__dark">{{
                  slotData.day.day
                }}</span>
              </span>
            </div>

            <div
              v-for="(attribute, i) in slotData.attributes"
              :key="`day-attr-${i}`"
              :class="{
                opened: attribute.customData.closed === 0,
                closed: attribute.customData.closed === 1,
                default: attribute.customData.closed === 3
              }"
              class="custom-calendar--day-content-wrapper"
            >
              <div class="date-header">
                <span class="disponibility-flag">
                  <span class="day-label">{{ slotData.day.day }}</span>
                </span>
              </div>

              <div class="date-content">
                <!-- QUANTIDADE DE HÓSPEDES -->
                <p v-if="attribute.customData.guest" class="guest">
                  {{ attribute.customData.guest }}
                </p>
                <!-- PREÇO DA ACOMODAÇÃO -->
                <p v-if="attribute.customData.price" class="price">
                  {{ attribute.customData.price }}
                </p>
                <!-- DETALHE DA TARIFA -->
                <p v-if="attribute.customData.detail" class="detail">
                  {{ attribute.customData.detail }}
                </p>
              </div>

              <div class="date-bottom"></div>
            </div>
          </div>
        </slot>
      </template>

      <!-- RECEBE DEMAIS SLOTS DO COMPONENTE PAI-->
      <template v-for="name in otherSlots" v-slot:[name]="slotData">
        <slot :name="name" v-bind="slotData" />
      </template>
    </Calendar>
  </div>
</template>

<script>
import { differenceInCalendarMonths } from 'date-fns'
import Calendar from 'v-calendar/lib/components/calendar.umd'

export default {
  name: 'FullCalendar',
  components: {
    Calendar
  },
  props: {
    /** Perído de tempo que vai ser apresentado no calendário */
    period: {
      type: Object,
      default: () => {
        return {
          rawStart:
            'Sat Jun 01 2021 18:31:49 GMT-0300 (Horário Padrão de Brasília)',
          start: '2021-06-01',
          rawEnd:
            'Tue Jun 11 2021 18:31:49 GMT-0300 (Horário Padrão de Brasília)',
          end: '2021-06-11'
        }
      },
      required: true
    },
    /**
     * Valores de cada dia do calendário
     * @example {
          customData: {
            guest: '1 Pax',
            price: 'R$ 304,09',
            detail: + 14% sobre a base' // TODO verificar a forma que os dados virão para esse atributo,
            closed: 1 // 0 === aberto, 1 === fechado
          },
          dates: [
            new Date(2021, 5, 1),
            new Date(2021, 5, 8),
            new Date(2021, 5, 15)
          ]
        }
     */
    attributes: {
      type: Array,
      required: true,
      default: () => []
    },
    /**
     * Se deve exibir a versão comprimida
     * @see https://www.figma.com/file/9AFe6i7bVhMup1bYeppCU7/Tarifas?node-id=1%3A8572
     */
    compress: {
      type: Boolean,
      default: false
    },

    /** Define se deve aprensetar um em baixo do outro no modo coluna
     * ou ao lado, no modo linha
     */
    isColumn: {
      type: Boolean,
      default: false
    },

    /** Mascara do v-calendar
     * https://vcalendar.io/
     */
    masks: {
      type: Object,
      default: () => {
        return {
          weekdays: 'WWWW'
        }
      }
    }
  },

  computed: {
    startDate() {
      return new Date(this.period.rawStart)
    } /** Data de início do calendário */,
    endDate() {
      return new Date(this.period.rawEnd)
    } /** Data final do calendário */,
    /**
     * Retorna a quantidade de calendários que deve ser apresentada
     */
    rows() {
      /** Pega a diferença de meses no período para saber quantos calendários apresentar */
      return (
        differenceInCalendarMonths(
          new Date(this.period.rawEnd),
          new Date(this.period.rawStart)
        ) + 1
      ) /** Adiciona 1 para considerar o primeiro mês */
    },
    /**
     * Retorna os slots inseridos no componente pai
     */
    otherSlots() {
      return Object.keys(this.$scopedSlots).filter(
        (slotName) => slotName !== 'day-content'
      )
    }
  }
}
</script>

<style lang="scss" scoped>
::-webkit-scrollbar {
  width: 0px;
}
::-webkit-scrollbar-track {
  display: none;
}
::v-deep .custom-calendar {
  &.vc-container {
    border-radius: 0;
    border: none;

    .vc-pane {
      border: 1px solid $gray-border;
    }

    .vc-pane + .vc-pane {
      margin-top: 30px;
    }

    .vc-arrows-container {
      display: none;
    }

    .vc-header {
      background-color: $white;
      padding: 14px 25px;
    }

    .vc-title {
      font-size: font-size('size-large');
      font-weight: font-weight('weight-light');
      text-transform: capitalize;
      line-height: 1;
    }

    .vc-weeks {
      padding: 0;
    }

    .vc-weekday {
      padding: 15px 0;
      background-color: $gray-lightest;
      font-size: font-size('size-medium');
      font-weight: font-weight('weight-normal');
      color: $gray-darkest;
      text-transform: capitalize;
      border-bottom: 1px solid $gray-border;
      border-top: 1px solid $gray-border;

      &:last-child {
        border-left: 1px solid $gray-border;
      }

      &:nth-child(7) {
        border-right: none;
      }
    }

    .vc-day {
      padding: 0;
      height: 62px;
      min-width: 80px;
      text-align: left;
      background-color: white;
      color: $gray-darkest;

      .day-label {
        font-size: font-size('size-medium');
      }

      &:not(.on-bottom) {
        border-bottom: 1px solid $gray-border;

        &.weekday-1 {
          border-bottom: 1px solid $gray-border;
        }
      }

      &:not(.on-right) {
        border-right: 1px solid $gray-border;
      }
    }

    .vc-day-dots {
      margin-bottom: 5px;
    }
  }

  &--day {
    height: 100%;
    background-color: $gray-lightest;

    &-content-wrapper {
      display: grid;
      grid-template-rows: 25px 1fr 20px;
      height: 100%;
      padding: 10px;
    }

    .date {
      &-header {
        align-self: flex-start;
      }

      &-content {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        align-content: center;
        justify-content: center;

        p {
          width: 100%;
          text-align: center;

          & + p {
            margin-top: 7px;
          }
        }

        .guest {
          font-size: font-size('size-small');
          text-transform: capitalize;
        }

        .price {
          font-size: font-size('size-medium');
          font-weight: font-weight('weight-bold');
        }

        .discount {
          font-size: font-size('size-small');
          font-weight: font-size('weight-light');
          color: $gray-dark;
          line-height: inherit;
          padding-top: 10px;
          margin-bottom: 5px;
          .value {
            color: $red-3;
          }
        }
      }
    }

    .disponibility-flag {
      display: block;
      margin: {
        bottom: 5px;
        right: 5px;
      }
      border-radius: 50%;
      width: 27px;
      height: 27px;
      text-align: center;
    }

    .day-label {
      font-size: 14px;
      font-weight: font-weight('weight-bold');
      color: pmw-colors(grey-00);
      line-height: 25px;

      &__dark {
        color: pmw-colors(grey-90);
        font-weight: font-weight('weight-light');
      }
    }

    .opened,
    .closed {
      background-color: pmw-colors(grey-00);

      .day-label {
        margin-top: 8px;
      }
    }

    .opened {
      .disponibility-flag {
        background-color: pmw-colors(success-100);
      }
    }

    .default {
      .disponibility-flag {
        background-color: pmw-colors(blue-100);
      }
    }

    .closed {
      .disponibility-flag {
        background-color: pmw-colors(error-100);
      }
    }
  }

  &__normal {
    &.vc-container {
      .vc-day {
        height: 75px;
      }
    }
  }

  &__compressed {
    &.vc-container {
      .vc-day {
        height: 75px;
      }
    }
  }

  &__column {
    .vc-pane + .vc-pane {
      margin-top: 0 !important;
    }
    .vc-pane-layout {
      gap: 30px;
      grid-template-columns: repeat(2, 1fr) !important;
    }
  }
}
</style>
